import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Auth from './components/Auth';
import VerifyEmail from './components/VerifyEmail';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import AdminDashboard from './components/AdminDashboard';
import Profile from './components/Profile';
import Pricing from './components/Pricing';
import SubscriptionSuccess from './components/SubscriptionSuccess';
import SubscriptionCancel from './components/SubscriptionCancel';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import ProtectedRoute from './components/ProtectedRoute';
import VocabularyManager from './components/VocabularyManager';
import VocabularyImporter from './components/VocabularyImporter';
import VocabularyCleanup from './components/VocabularyCleanup';
import Games from './components/Games';
import Flashcards from './components/games/Flashcards';
import MultipleChoice from './components/games/MultipleChoice';
import FillInBlank from './components/games/FillInBlank';
import MemoryMatch from './components/games/MemoryMatch';
import AudioPronunciation from './components/games/AudioPronunciation';
import PossessivesGame from './components/games/PossessivesGame';
import LearnPossessives from './components/LearnPossessives';
import Progress from './components/Progress';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-red-50">
        <Router>
          <Navbar />
          <main className="pt-16">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Auth />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/subscription/success" element={<SubscriptionSuccess />} />
              <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              
              {/* Protected Routes */}
              <Route path="/vocabulary" element={
                <ProtectedRoute>
                  <VocabularyManager />
                </ProtectedRoute>
              } />
              <Route path="/vocabulary/import" element={
                <ProtectedRoute>
                  <VocabularyImporter />
                </ProtectedRoute>
              } />
              <Route path="/vocabulary/cleanup" element={
                <ProtectedRoute>
                  <VocabularyCleanup />
                </ProtectedRoute>
              } />
              <Route path="/games" element={
                <ProtectedRoute>
                  <Games />
                </ProtectedRoute>
              } />
              <Route path="/games/flashcards" element={
                <ProtectedRoute>
                  <Flashcards />
                </ProtectedRoute>
              } />
              <Route path="/games/multiple-choice" element={
                <ProtectedRoute>
                  <MultipleChoice />
                </ProtectedRoute>
              } />
              <Route path="/games/fill-blank" element={
                <ProtectedRoute>
                  <FillInBlank />
                </ProtectedRoute>
              } />
              <Route path="/games/memory-match" element={
                <ProtectedRoute>
                  <MemoryMatch />
                </ProtectedRoute>
              } />
              <Route path="/games/pronunciation" element={
                <ProtectedRoute>
                  <AudioPronunciation />
                </ProtectedRoute>
              } />
              <Route path="/games/possessives" element={
                <ProtectedRoute>
                  <PossessivesGame />
                </ProtectedRoute>
              } />
              <Route path="/learn/possessives" element={
                <ProtectedRoute>
                  <LearnPossessives />
                </ProtectedRoute>
              } />
              <Route path="/progress" element={
                <ProtectedRoute>
                  <Progress />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </Router>
      </div>
    </AuthProvider>
  );
}

export default App;